import React from "react";
import { Link } from "react-router-dom";
import { companyInfo } from "../../../data/CompanyData";

const TabHover = () => {
  return (
    <div className=" ">
      <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-2 py-10 px-20">
        {companyInfo.map((item) => (
          <Link
            to={item.link}
            key={item.id}
            className="flex gap-4 justify-start  items-start"
          >
            <div className="flex gap-4 justify-start  items-start">
              <img src={item.icon} alt="" />

              <div>
                <h3 className="font-semibold mt-[-12px] flex gap-2 items-center">
                  {item.title}
                  <span className="text-green-800 bg-[#ECFDF3] text-[13px] px-2  rounded-full leading-[25px]">
                    {item?.options}
                  </span>
                </h3>

                <h3 className="text-sm text-accent">{item.text}</h3>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <p className="bg-[#B4FDD9] text-primary text-lg p-5 text-center ">
        Looking for a new career? Get in touch
      </p>
    </div>
  );
};

export default TabHover;
